import { render } from "./TarifsAssurance.vue?vue&type=template&id=78d330ce&scoped=true"
import script from "./TarifsAssurance.vue?vue&type=script&lang=js"
export * from "./TarifsAssurance.vue?vue&type=script&lang=js"

import "./TarifsAssurance.vue?vue&type=style&index=0&id=78d330ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d330ce"]])

export default __exports__